<template>
    <div>
        <card-header title="Event Descriptions" icon="fa-align-left"/>
        <card-toolbar>
            <button @click="$openCard('new-event-description', {}, card)"><i class="fas fa-plus mr-2"/>New Description</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <template v-if="descriptionsByType(null).length">
                    <subheader-list-item title="All Event Types" icon="fas fa-align-left" :badge="descriptionsByType(null).length"/>
                    <navigation-list-item
                        v-for="d in descriptionsByType(null)"
                        :key="d.id"
                        :title="d.title"
                        :subtitle="preview(d.description)"
                        icon="fa-align-left"
                        class="t-card-list-item"
                        :active="child && child.definition.component === 'edit-event-description' && child.props.descriptionId === d.id.toString()"
                        @click="$openCard('edit-event-description', {descriptionId: d.id}, card)"
                    />
                </template>

                <template v-for="type in typesPresent">
                    <subheader-list-item :key="'sh-' + type" :title="eventTypeLabel(type)" icon="fas fa-align-left" :badge="descriptionsByType(type).length"/>
                    <navigation-list-item
                        v-for="d in descriptionsByType(type)"
                        :key="d.id"
                        :title="d.title"
                        :subtitle="preview(d.description)"
                        icon="fa-align-left"
                        class="t-card-list-item"
                        :active="child && child.definition.component === 'edit-event-description' && child.props.descriptionId === d.id.toString()"
                        @click="$openCard('edit-event-description', {descriptionId: d.id}, card)"
                    />
                </template>

                <container-list-item padded v-if="!descriptions.length">
                    <i class="far fa-info-circle mr-3 ml-2 fa-fw"/>No saved event descriptions yet. Create one and it will be offered on matching events.
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import {client as http} from '@/http_client';
    import {EVENT_TYPES, eventTypeLabel} from './eventTypes';

    export default {
        props: ['card', 'child', 'props'],
        components: {ContainerListItem, NavigationListItem, SubheaderListItem, CardBody, CardToolbar, CardList, CardHeader},
        data: function() {
            return {
                descriptions: []
            };
        },
        computed: {
            typesPresent() {
                // Keep the form's type order rather than first-seen order.
                return EVENT_TYPES.map(t => t.value).filter(type => this.descriptions.some(d => d.event_type === type));
            }
        },
        methods: {
            eventTypeLabel,
            loadDescriptions(force) {
                this.$emit('loading', true);
                http.get('/api/event_descriptions', {force}).then(response => {
                    this.descriptions = response.data;
                    this.$emit('loading', false);
                });
            },
            descriptionsByType(type) {
                return this.descriptions.filter(d => d.event_type === type);
            },
            preview(html) {
                const text = (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
                return text.length > 90 ? text.slice(0, 90) + '…' : text;
            },
            reload() {
                this.loadDescriptions(true);
            }
        },
        mounted() {
            this.loadDescriptions();
        }
    };
</script>
